'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import { RouteErrorPage } from '@/components/shared/error'

interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error({ error }: ErrorProps) {
  useEffect(() => {
    // Capture error with additional context
    Sentry.captureException(error, {
      tags: {
        errorBoundary: 'route-error',
        errorType: '500',
      },
      extra: {
        errorDigest: error.digest,
        errorMessage: error.message,
        errorStack: error.stack,
      },
    })
  }, [error])

  return <RouteErrorPage />
}
